import React from 'react';
import PropTypes from 'prop-types';
import { Chart, Bar } from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';

class AdminChart extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      mode: props.mode,
      data: {}
    };

    this.fetchData = this.fetchData.bind(this);
    this.changeMode = this.changeMode.bind(this);
  }

  changeMode(mode) {
    this.setState(
      {
        mode: mode
      }, () => {
        this.fetchData();
      }
    )
  }

  getDatasets(data) {
    const definition = {
      total_users: {
        label: 'Nombre d\'utilisateurs',
        data: data.data,
        backgroundColor: 'transparent',
        pointRadius: 4,
        pointHoverRadius: 8,
        borderWidth: 4,
        borderColor: '#005cbd',
        pointBorderColor: '#005cbd',
        pointBackgroundColor: '#005cbd',
        type: 'line',
        order: 1,
        datalabels: {
          align: 'end',
          anchor: 'end',
          backgroundColor: '#005cbd',
          borderRadius: 4,
          color: 'white',
          formatter: function(value){
            return value;
          }
        }
      },
      new_users: {
        label: 'Nouveaux utilisateurs',
        data: data.data,
        backgroundColor: '#069162',
        type: 'bar',
        order: 2,
        datalabels: {
          align: 'end',
          anchor: 'end',
          backgroundColor: function(context) {
            return context.dataset.backgroundColor;
          },
          borderRadius: 4,
          color: 'white',
          formatter: function(value){
            return value;
          }
        }
      },
      active_users: {
        label: 'Nombre d\'utilisateurs actifs',
        data: data.data,
        backgroundColor: '#EF992B',
        type: 'bar',
        order: 1,
        datalabels: {
          align: 'end',
          anchor: 'end',
          backgroundColor: function(context) {
            return context.dataset.backgroundColor;
          },
          borderRadius: 4,
          color: 'white',
          formatter: function(value){
            return value;
          }
        }
      },
      total_dictations: {
        label: 'Nombre total de dictées',
        data: data.data,
        backgroundColor: '#005cbd',
        type: 'bar',
        order: 3,
        datalabels: {
          align: 'end',
          anchor: 'end',
          backgroundColor: function(context) {
            return context.dataset.backgroundColor;
          },
          borderRadius: 4,
          color: 'white',
          formatter: function(value){
            return value;
          }
        }
      },
      dictations_count: {
        label: 'Nombre de dictées',
        data: data.data,
        backgroundColor: '#069162',
        type: 'bar',
        order: 3,
        datalabels: {
          align: 'end',
          anchor: 'end',
          backgroundColor: function(context) {
            return context.dataset.backgroundColor;
          },
          borderRadius: 4,
          color: 'white',
          formatter: function(value){
            return value;
          }
        }
      },
      wordles_count: {
        label: 'Nombre de parties de Le Mot',
        data: data.data,
        backgroundColor: '#005cbd',
        type: 'bar',
        order: 1,
        datalabels: {
          align: 'end',
          anchor: 'end',
          backgroundColor: function(context) {
            return context.dataset.backgroundColor;
          },
          borderRadius: 4,
          color: 'white',
          formatter: function(value){
            return value;
          }
        }
      },
      wordles_won: {
        label: 'Nombre de gagnants Le Mot',
        data: data.data,
        backgroundColor: '#069162',
        type: 'bar',
        order: 1,
        datalabels: {
          align: 'end',
          anchor: 'end',
          backgroundColor: function(context) {
            return context.dataset.backgroundColor;
          },
          borderRadius: 4,
          color: 'white',
          formatter: function(value){
            return value;
          }
        }
      },
      cemantixes_count: {
        label: 'Nombre de parties de Cémantix',
        data: data.data,
        backgroundColor: '#005cbd',
        type: 'bar',
        order: 1,
        datalabels: {
          align: 'end',
          anchor: 'end',
          backgroundColor: function(context) {
            return context.dataset.backgroundColor;
          },
          borderRadius: 4,
          color: 'white',
          formatter: function(value){
            return value;
          }
        }
      },
      cemantixes_won: {
        label: 'Nombre de gagnants Cémantix',
        data: data.data,
        backgroundColor: '#069162',
        type: 'bar',
        order: 1,
        datalabels: {
          align: 'end',
          anchor: 'end',
          backgroundColor: function(context) {
            return context.dataset.backgroundColor;
          },
          borderRadius: 4,
          color: 'white',
          formatter: function(value){
            return value;
          }
        }
      },
      find_errors_dictations_count: {
        label: 'Nombre de dictées à corriger',
        data: data.data,
        backgroundColor: '#D33737',
        type: 'bar',
        order: 2,
        datalabels: {
          align: 'end',
          anchor: 'end',
          backgroundColor: function(context) {
            return context.dataset.backgroundColor;
          },
          borderRadius: 4,
          color: 'white',
          formatter: function(value){
            return value;
          }
        }
      },
      flash_dictations_count: {
        label: 'Nombre de dictées flash',
        data: data.data,
        backgroundColor: '#EF992B',
        type: 'bar',
        order: 2,
        datalabels: {
          align: 'end',
          anchor: 'end',
          backgroundColor: function(context) {
            return context.dataset.backgroundColor;
          },
          borderRadius: 4,
          color: 'white',
          formatter: function(value){
            return value;
          }
        }
      },
      average_score: {
        label: 'Score moyen',
        data: data.data,
        backgroundColor: 'transparent',
        pointRadius: 4,
        pointHoverRadius: 8,
        borderWidth: 4,
        borderColor: '#F05A39',
        pointBorderColor: '#F05A39',
        pointBackgroundColor: '#F05A39',
        type: 'line',
        order: 2,
        datalabels: {
          align: 'end',
          anchor: 'end',
          backgroundColor: '#F05A39',
          borderRadius: 4,
          color: 'white',
          formatter: function(value){
            return value + ' %';
          }
        }
      },
      per_user_dictation: {
        label: 'Nombre moyen de dictées par utilisateur',
        data: data.data,
        backgroundColor: 'transparent',
        pointRadius: 4,
        pointHoverRadius: 8,
        borderWidth: 4,
        borderColor: '#EF992B',
        pointBorderColor: '#EF992B',
        pointBackgroundColor: '#EF992B',
        type: 'line',
        order: 2,
        datalabels: {
          align: 'end',
          anchor: 'end',
          backgroundColor: '#EF992B',
          borderRadius: 4,
          color: 'white',
          formatter: function(value){
            return value;
          }
        }
      }
    }
    return this.props.datasets.map(dataset => definition[dataset]);
  }

  fetchData() {
    fetch(`${this.props.endpoint}?mode=${this.state.mode}`)
      .then(response => response.json())
      .then(data => {
        this.setState(
          {
            options: {
              responsive: true,
              scales: {
                xAxes: [{
                    stacked: this.state.mode == "day" ? true : false
                }]
              }
            },
            data: {
              datasets: this.getDatasets(data),
              labels: data.labels
            }
          }
        )
      })
  }

  componentDidMount() {
    this.fetchData();

    Chart.Legend.prototype.afterFit = function() {
      this.height = this.height + 26;
    };
  }

  render() {
    return (
      <div>
        {
          this.props.timeline && (
            <div>
              <ul className="mb-4">
                <li className={`inline-block rounded py-2 px-4 font-semibold cursor-pointer mr-2 ${this.state.mode == "day" ? "bg-primary text-white" : "bg-grey-light"}`} onClick={() => this.changeMode("day")}>Jours</li>
                <li className={`inline-block rounded py-2 px-4 font-semibold cursor-pointer mr-2 ${this.state.mode == "week" ? "bg-primary text-white" : "bg-grey-light"}`} onClick={() => this.changeMode("week")}>Semaines</li>
                <li className={`inline-block rounded py-2 px-4 font-semibold cursor-pointer mr-2 ${this.state.mode == "month" ? "bg-primary text-white" : "bg-grey-light"}`} onClick={() => this.changeMode("month")}>Mois</li>
                <li className={`inline-block rounded py-2 px-4 font-semibold cursor-pointer mr-2 ${this.state.mode == "year" ? "bg-primary text-white" : "bg-grey-light"}`} onClick={() => this.changeMode("year")}>Années</li>
              </ul>
            </div>
          )
        }
        <Bar data={this.state.data} options={this.state.options} />
      </div>
    );
  }
}

AdminChart.propTypes = {
  user_id: PropTypes.number,
  timeline: PropTypes.bool,
  mode: PropTypes.string,
  endpoint: PropTypes.string
};

AdminChart.defaultProps = {
  mode: "day",
  timeline: true
}

export default AdminChart;
